import useBibibopDeliveryRanking, {
  bibibopDeliveryRankingConfigs,
} from './useDeliveryRanking'
import useBibibopListLocationDeliveryKpis, {
  bibibopListLocationDeliveryKpisConfigs,
} from './useListLocationDeliveryKpis'
import useBibibopListLocationGroupDeliveryKpis, {
  bibibopListLocationGroupDeliveryKpisConfigs,
} from './useListLocationGroupDeliveryKpis'

export const configs = {
  bibibopListLocationGroupDeliveryKpis:
    bibibopListLocationGroupDeliveryKpisConfigs,
  bibibopListLocationDeliveryKpis: bibibopListLocationDeliveryKpisConfigs,
  bibibopDeliveryRanking: bibibopDeliveryRankingConfigs,
}

export const api = {
  bibibopListLocationGroupDeliveryKpis: useBibibopListLocationGroupDeliveryKpis,
  bibibopListLocationDeliveryKpis: useBibibopListLocationDeliveryKpis,
  bibibopDeliveryRanking: useBibibopDeliveryRanking,
}
